<div class="container" appDnd (fileDropped)="onFileDropped($event)">
  <input type="file" #fileInput  #fileDropRef id="fileDropRef"  (change)="fileBrowseHandler($event.target.files)" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" />
  @if (!isUploading) {
    <div>
      <mat-icon class="upload_icon">cloud_upload</mat-icon>
      <p>Already have the upload file ready? <br>
      Drag and Drop or click below to upload the file</p>
      <button mat-flat-button color="primary" for="fileDropRef">Browse for file</button>
    </div>
  }
  @if (isUploading) {
    <div>
      <p class="uploading-msg">Please wait while we are validating the uploaded file.</p>
    </div>
  }
</div>
<br>
  <div fxLayout="column" fxLayoutAlign="start center" class="margin_auto left_margin">
    <div>Allowed File Type: xlsx</div>
    <div>Max. orders per file: 500</div>
  </div>
  <br>
    <div class="files-list">
      @for (file of files; track file; let i = $index) {
        <div class="single-file">
          <div class="file-icon" style="width: 50px"><mat-icon> attach_file</mat-icon>
        </div>
        <div class="info1">
          <h4 class="name">
            {{file?.name}}
          </h4>
          <p class="size">
            {{formatBytes(file?.size)}}
          </p>
          <app-progress-bar [progress]="file?.progress"></app-progress-bar>
        </div>
        <div class="delete" (click)="deleteFile(i)" fxLayoutAlign="center center">
          <mat-icon color="primary">delete</mat-icon>
        </div>
      </div>
    }
  </div>